export default {
    studentsInLesson: [],
    questions: [],
    question: [],
    answers: []
}